/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

// Composition: helper functions that are useful for various DateTimeParser implementations

import { LocaleManager } from "abweb/service/locale/LocaleManager";
const FORMAT_WHITESPACE_RE = /[ \u202F]/; // space or narrow space (narrow space can occur in intl formats)
const TWO_FORMAT_WHITESPACE_RE = /[ \u202F][ \u202F]/; // two consecutive whitespace characters
const FORMAT_WHITESPACE_GLOBAL = /[ \u202F][ \u202F]*/g; // space or narrow space (narrow space can occur in intl formats)

export function createDateTimeParseError(parseStr, parseContext) {
  return new Error(`DateTime value '${parseStr}' can not be parsed as it is not in expected ${parseContext.parseGrammarName} parse format '${parseContext.parseFormat}'.`
  // Conservatively always include locale in error msg (might not be relevant if parse format is locale-independent)
  + `  Current datetime locale is: ${LocaleManager.datetimeFormatLocale}`);
}

// Most (all?) parseFormats do not have trailing/leading spaces, nor multiple spaces in a row embedded within them.
// If that is true, then can 'fixup' the corresponding parseStr whitespace so that it is more forgiving of fat-fingered whitespace
export function shouldFixupParseStringWhitespace(parseFormat) {
  return !!parseFormat?.length &&
  // no defined whitespace at beginning or end (trim would remove these), or multiple spaces in middle.
  !(FORMAT_WHITESPACE_RE.test(parseFormat[0]) || FORMAT_WHITESPACE_RE.test(parseFormat[parseFormat.length - 1]) || TWO_FORMAT_WHITESPACE_RE.test(parseFormat));
}

/**
 * @param fixupWhitespace if true, will trim trailing/leading spaces and reduce multiple consecutive interior spaces to single space
 * @return non-empty parseStr suitable for subsequent parsing.
 * Will return undefined if resulting parseStr is empty, null, or undefined
 */
export function preParseValue(parseStr, fixupWhitespace) {
  if (fixupWhitespace) {
    parseStr = parseStr?.trim().replace(FORMAT_WHITESPACE_GLOBAL, " ");
  }
  return parseStr ?? undefined;
}
//# sourceMappingURL=DateTimeParserHelper.js.map
